<template>
  <v-text-field
    hide-details
    :label="label"
    suffix="cm"
    :value="data"
    @change="$emit('change', $event)"
   ></v-text-field>
</template>

<script>
export default {
    name: 'InsertionLengthInput',

    props: {
        data: {
            type: [String, Number],
            required: false
        },
    },

    data() {
        return {
            field: 'insertionLength',
            label: this.$t('report_preview.insertion_length'),
        }
    },

}
</script>